export default __webpack_public_path__ + "static/media/toyota-fortuner.675b1159.png";